<template>
  <pt-old-to-new-detail class="pt-old-to-new-detail__withData"  :id="id" :oldAndNewDetail="oldAndNewDetail"
  :submitLoading="submitLoading" @submit="submit" :detailLoading="detailLoading" :type="type" ref="form"></pt-old-to-new-detail>
</template>

<script>
import PtOldToNewDetail from './index'
export default {
  name: 'pt-old-to-new-detail__withData',
  components: {
    'pt-old-to-new-detail': PtOldToNewDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  data () {
    return {
      oldAndNewDetail: {},
      submitLoading: false,
      detailLoading: false
    }
  },
  methods: {
    submit (data) {
      if (this.form.fromOld) {
        this.form.fromOld.validate().then(_ => {
          if (this.form.fromNew) {
            this.form.fromNew.validate().then(_ => {
              this.submitGetData(data)
            })
          } else {
            this.submitGetData(data)
          }
        })
      } else if (this.form.fromNew) {
        this.form.fromNew.validate().then(_ => {
          this.submitGetData(data)
        })
      }
    },
    submitGetData (data) {
      this.submitLoading = true
      this.$store.dispatch('bringNewReward', data).then(res => {
        this.submitLoading = false
        this.$message.success('发放成功')
        history.go(-1)
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '发放失败')
      })
    },
    customerBringNewDetail () {
      this.detailLoading = true
      this.$store.dispatch('customerBringNewDetail', this.id).then(res => {
        this.detailLoading = false
        this.oldAndNewDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取脐荐康详情失败')
      })
    }
  },
  created () {
    this.customerBringNewDetail()
  }
}
</script>
